exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".theatre-title {\r\n  color: rgba(255, 255, 255, 0.87);\r\n  font-size: 1rem;\r\n}\r\n\r\n.showtime-type-title {\r\n  color: rgba(255, 255, 255, 0.72);\r\n  font-style: italic;\r\n  font-weight: 300;\r\n}\r\n\r\n.schedule {\r\n  display: block;\r\n  margin-left: 20px;\r\n}\r\n\r\n.coming-soon-img {\r\n  display: block;\r\n  width: 100%;\r\n  max-width: 600px;\r\n  margin: auto;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/movies/movie-showtime-list/movie-showtime-list.component.css
// module id = ../../../../../src/app/movies/movie-showtime-list/movie-showtime-list.component.css
// module chunks = 4